import * as types from '../../constants/ModalsActionTypes';
import { createAction } from 'redux-actions';

export const showModal = createAction(types.ADD_MODAL);
export const hideModal = createAction(types.HIDE_MODAL);
export const hideAllModals = createAction(types.HIDE_ALL_MODALS);
